import {getFeatureSettings, setFeatureEnabled, setLauncherVisible} from './config';
import {mountLauncher} from './launcher';
import './styles.scss';

declare global {
  interface Window {
    xTgDownloader?: {
      settings: typeof getFeatureSettings;
      enable: (feature: 'download' | 'copy' | 'forward') => void;
      disable: (feature: 'download' | 'copy' | 'forward') => void;
      showLauncher: () => void;
      hideLauncher: () => void;
    };
  }
}

window.xTgDownloader = {
  settings: getFeatureSettings,
  enable: (feature) => setFeatureEnabled(feature, true),
  disable: (feature) => setFeatureEnabled(feature, false),
  showLauncher: () => setLauncherVisible(true),
  hideLauncher: () => setLauncherVisible(false)
};

const DOCUMENT_TITLE = 'X';

const enforceDocumentTitle = () => {
  if(document.title !== DOCUMENT_TITLE) {
    document.title = DOCUMENT_TITLE;
  }
};

enforceDocumentTitle();
new MutationObserver(enforceDocumentTitle).observe(document.head, {
  childList: true,
  characterData: true,
  subtree: true
});

document.documentElement.dataset.xTgDownloader = 'enabled';

if(document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', mountLauncher, {once: true});
} else {
  mountLauncher();
}
